import { render } from "./Valdiator.vue?vue&type=template&id=473ade57&scoped=true"
import script from "./Valdiator.vue?vue&type=script&lang=js"
export * from "./Valdiator.vue?vue&type=script&lang=js"

import "./Valdiator.vue?vue&type=style&index=0&id=473ade57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473ade57"]])

export default __exports__